require('./bootstrap');
require('./chat');

// Bootstrap is loaded via CDN in the layout file to ensure Popper.js is included and to avoid build issues.
// window.bootstrap = require('bootstrap');